export default __webpack_public_path__ + "static/media/16eebebfb4588a5396b3c036a7f8b07d.svg";